import React, { useContext, useEffect, useState } from 'react';
import { SimpleStorageContext } from '../../context/simpleStorage/simpleStorageContext';
import SimpleStorageImagesForm from './ImagesForm';
import VideosForm from './VideosForm';
import Gallery from './Gallery';
import Swal from 'sweetalert2';

export const SimpleStorageComponent = ({ entity_id, entity_code }) => {
    const [mediaType, setMediaType] = useState('images');

    const {
        images,
        videos,
        loading,
        error,
        fetchImages,
        fetchVideos
    } = useContext(SimpleStorageContext);

    useEffect(() => {
        if (entity_id) {
            fetchImages(entity_id, entity_code);
            fetchVideos(entity_id, entity_code);
        }
    }, [entity_id]);

    useEffect(() => {
        if (error) {
            Swal.fire('Error', error, 'error');
        }
    }, [error]);

    const handleUploadComplete = () => {
        fetchImages(entity_id, entity_code);
    };

    const handleAddVideoComplete = () => {
        fetchVideos(entity_id, entity_code);
    };

    const handleDeleteComplete = () => {
        if (mediaType === 'images') {
            fetchImages(entity_id, entity_code);
        } else {
            fetchVideos(entity_id, entity_code);
        }
    };

    const currentItems = mediaType === 'images' ? images : videos;

    return (
        <div className='container-fluid'>
            <ul className='nav nav-pills mb-4'>
                <li className='nav-item'>
                    <button
                        className={`nav-link ${mediaType === 'images' ? 'active' : ''}`}
                        onClick={() => setMediaType('images')}
                    >
                        <i className='fas fa-image'></i> Imágenes ({images.length})
                    </button>
                </li>
                <li className='nav-item'>
                    <button
                        className={`nav-link ${mediaType === 'videos' ? 'active' : ''}`}
                        onClick={() => setMediaType('videos')}
                    >
                        <i className='fas fa-video'></i> Videos ({videos.length})
                    </button>
                </li>
            </ul>

            <div className='row'>
                <div className='col-12 col-lg-5 mb-4'>
                    <div className='card'>
                        <div className='card-body'>
                            <h5 className='card-title'>
                                {mediaType === 'images' ? 'Subir Imágenes' : 'Agregar Videos'}
                            </h5>
                            {mediaType === 'images' ? (
                                <SimpleStorageImagesForm
                                    idCasa={entity_id}
                                    entityCode={entity_code}
                                    onUploadComplete={handleUploadComplete}
                                />
                            ) : (
                                <VideosForm
                                    idCasa={entity_id}
                                    entityCode={entity_code}
                                    onAddComplete={handleAddVideoComplete}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className='col-12 col-lg-7'>
                    <Gallery
                        items={currentItems}
                        type={mediaType}
                        idCasa={entity_id}
                        loading={loading}
                        onDeleteComplete={handleDeleteComplete}
                        entityCode={entity_code}
                    />
                </div>
            </div>
        </div>
    );
};
